import { rejectAvailable, acceptAvailable } from 'app/dataProviders/encashments/status'

import { Column } from '../columns'
import { Status } from './Status'
import { CellTypeMoney } from './CellTypeMoney'
import { Action } from './Action'
import { EncashmentsSummaryType, encashmentsDateFormat } from 'app/dataTypes/reports/data'
import SimpleDate from 'app/common/classes/simple-date'
import { EncashmentsCount } from './EncashmentsCount'
import {
  EncashmentsAction,
  EncashmentsStatusAction,
} from 'app/dataTypes/reports/data/finances/encashments/action'

type Props = {
  columnKey: Column
  encashmentsSummary: EncashmentsSummaryType
  date: SimpleDate
  onChangeStatus: (params: EncashmentsStatusAction) => Promise<boolean>
  selectionMode: null | EncashmentsAction
  selection: Set<string>
  onChangeSelection: (orgID: string, checked: boolean) => void
}

export const Cell = ({
  columnKey,
  encashmentsSummary,
  date,
  onChangeStatus,
  selectionMode,
  selection,
  onChangeSelection,
}: Props) => {
  const {
    status,
    salePointId,
    schoolTitle,
    buildingTitle,
    salePointTitle,
    balanceAtTheBeginning,
    balanceAtTheEnd,
    revenue,
    collected,
    encashmentsCount,
    pendingDates,
  } = encashmentsSummary
  if (columnKey === Column.Title) {
    const enableSelection =
      (selectionMode === EncashmentsAction.Accept && acceptAvailable(status)) ||
      (selectionMode === EncashmentsAction.Reject && rejectAvailable(status))

    return (
      <Status
        status={status}
        schoolTitle={schoolTitle}
        buildingTitle={buildingTitle}
        salePointTitle={salePointTitle}
        salePointId={salePointId}
        selectionMode={enableSelection}
        selected={selection.has(salePointId)}
        onClick={onChangeSelection}
      />
    )
  }

  if (columnKey === Column.Date) {
    return <div>{date?.getString(encashmentsDateFormat)}</div>
  }

  if (columnKey === Column.Action) {
    return (
      <Action
        status={status}
        schoolTitle={schoolTitle}
        date={date}
        salePointId={salePointId}
        salePointTitle={salePointTitle}
        onChangeStatus={onChangeStatus}
        pendingDates={pendingDates}
      />
    )
  }

  if (columnKey === Column.BalanceAtTheBeginning) {
    return <CellTypeMoney value={balanceAtTheBeginning} />
  }
  if (columnKey === Column.BalanceAtTheEnd) {
    return <CellTypeMoney value={balanceAtTheEnd} />
  }
  if (columnKey === Column.Revenue) {
    return <CellTypeMoney value={revenue} />
  }
  if (columnKey === Column.Collected) {
    return <CellTypeMoney status={status} value={collected} />
  }
  if (columnKey === Column.EncashmentsCount) {
    return <EncashmentsCount value={encashmentsCount} />
  }

  return <div>{'—'}</div>
}
